import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
// import $ from 'jquery';

import Splide from '@splidejs/splide';
import AOS from 'aos';
import Alpine from 'alpinejs'

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const swup = new Swup({
  plugins: [new SwupBodyClassPlugin(), new SwupScriptsPlugin(), new SwupScrollPlugin({offset: 150})]
}); 

const $d = $(document),
      $w = $(window);


let els = document.querySelectorAll(".questions_responses");
els.forEach(dragger);



// Events
swup.on('contentReplaced', init);
$d.on('click', '.menu-plus', menuOpen);
$d.on('click', '.menu-minus', menuClose);


$d.on('mouseenter', '.images_el', caption);
$d.on('mouseleave', '.images_el', clearCaption);


// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  startSliders();
  cookieNotice();
  menuClose();
  colorSet();
}

function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}



function startSliders() {
  if(document.querySelectorAll('.splide').length) { 
    let perPage = isMobile ? 1.5 : 3.5;
    let splide = new Splide( '.splide', {
      type: 'loop',
      focus  : 'left',
      perPage: perPage,
      arrows: true,
      pagination: false
    });

    splide.mount();
  }

}

function cookieNotice() {
  l('cookienotice');
  document.querySelector('.cookie_btn').addEventListener('click', setCookie);
}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  document.querySelector('.cookie').classList.add('hidden');
}



function menuOpen() {
  $('body').addClass('menu-open');

  console.log('menu open')
}


function menuClose() {
  $('body').removeClass('menu-open')

  console.log('menu close')
}



function colorSet() {
  let col = $('main').data('color');

  l(col);

  $("body").get(0).style.setProperty("--bg_color", col);
}







function dragger(el, index, arr) {
  let x = 0, y = 0, top = 0, left = 0;

  let draggingFunction = (e) => {
      document.addEventListener('mouseup', () => {
          document.removeEventListener("mousemove", draggingFunction);
      });
  
      el.scrollLeft = left - e.pageX + x;
      el.scrollTop = top - e.pageY + y;
  };
  
  el.addEventListener('mousedown', (e) => {
      e.preventDefault();
  
      y = e.pageY;
      x = e.pageX;
      top = el.scrollTop;
      left = el.scrollLeft;
  
      document.addEventListener('mousemove', draggingFunction);
  });
  

}



function caption() {

  let cap = $(this).find('img').data('caption');

  $('.caption').html(cap)
  $('.caption').show()
}

function clearCaption() {
  l('clear')

  $('.caption').html('')
  $('.caption').hide()

}